import React from 'react';
import { connect } from 'react-redux';
import { translator } from 'mage-i18n';
import { ButtonQuaternary, SeparatorSecondary, SpacerHorizontal, SpacerVertical, Typography, } from '@klarna/bubble-ui';
import { Column, Row, withResponsive } from 'mage-components';
import { LinkWithoutHref } from './LinkWithoutHref';
const SummarySection = ({ isDesktop, children, onEdit, t, title, titleLink, onTitleLinkClick, }) => (React.createElement(React.Fragment, null,
    (title || onEdit) && (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Column, { columns: { mobile: 9 } },
                React.createElement("div", { style: { display: 'flex', flexDirection: isDesktop ? 'row' : 'column' } },
                    React.createElement(Typography, { textToken: "text-style/headings/blocks/bold/tertiary" }, title),
                    titleLink && (React.createElement(React.Fragment, null,
                        React.createElement(SpacerHorizontal, { small: true }),
                        React.createElement("div", { style: { alignSelf: isDesktop ? 'flex-end' : undefined, marginBottom: 3 } },
                            React.createElement(LinkWithoutHref, { isUnderlined: true, colorToken: "colors/text/neutral", onPress: onTitleLinkClick }, titleLink)))))),
            onEdit && (React.createElement(Column, { columns: { mobile: 3 }, alignItems: { mobile: 'flex-end' } },
                React.createElement(ButtonQuaternary, { size: "small", onClick: onEdit }, t(`products-fe.containers.application_summary.buttons.edit`))))),
        React.createElement(SpacerVertical, { extraSmall: true }),
        React.createElement(SeparatorSecondary, null))),
    React.createElement(SpacerVertical, { small: true }),
    children));
export default connect(state => ({
    t: translator(state),
}))(withResponsive(SummarySection));
